const REFERRAL_TTL_MS = 30 * 24 * 60 * 60 * 1000;

const KEY = 'referral_code';

export function getStoredReferralCode(): string | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const { code, ts } = JSON.parse(raw);
    if (Date.now() - ts > REFERRAL_TTL_MS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    window.localStorage.removeItem(KEY);
    return null;
  }
}

export function storeReferralCode(code: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(KEY, JSON.stringify({ code, ts: Date.now() }));
}

/** Drop the stored code — used when revalidation finds it's no longer valid. */
export function clearStoredReferralCode(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(KEY);
}
